import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ARApiUrlBuilderService, ARRequestOptions } from '@relayter/core';
import { BaseApiRequestService } from './base-api-request.service';
import { environment } from '../../../environments/environment';
import { ApiConstants } from '../api.constant';
import { AppConstants } from '../../app.constants';

@Injectable({
    providedIn: 'root'
})
export class AuthenticationService extends BaseApiRequestService {
    public logout(): Observable<void> {
        const url = ARApiUrlBuilderService.urlFromComponents([
            environment.API_SERVER,
            ApiConstants.API_BASE_PATH,
            ApiConstants.API_PATH_ADMIN,
            ApiConstants.API_GROUP_AUTH,
            ApiConstants.API_METHOD_LOGOUT
        ]);

        const options: ARRequestOptions = new ARRequestOptions();
        options.method = ApiConstants.REQUEST_METHODS.DELETE;
        options.url = url;

        return this.executeWithoutResponse(options);
    }

    public redirectSso(ssoClientId: string, email: string, target: string = AppConstants.HOME_PAGE): void {
        if (!ssoClientId) {
            throw new Error('SSO login is not configured for this account.');
        }

        const normalizedOrigin = globalThis.location.origin.replace(/\/$/, '');
        const params: Record<string, string> = {
            client_id: environment.OAUTH_CLIENT_ID,
            return_url: `${normalizedOrigin}${AppConstants.CALLBACK_REDIRECT}?target=${encodeURIComponent(target)}`
        };

        if (email) {
            params['login_hint'] = email;
        }

        const loginUrl = ARApiUrlBuilderService.urlFromComponents(
            [environment.API_SERVER, ApiConstants.API_BASE_PATH, ApiConstants.API_GROUP_SSO_CLIENTS, ssoClientId, ApiConstants.API_METHOD_AUTHORIZE],
            params
        );

        globalThis.location.assign(loginUrl);
    }

    private executeWithoutResponse(options: ARRequestOptions): Observable<void> {
        return new Observable((observer) => {
            this.doRequest(options).subscribe({
                next: () => {
                    observer.next();
                    observer.complete();
                },
                error: (error: unknown) => observer.error(error)
            });
        });
    }
}
